import * as type from '../types/penTypes'

const defaultPen = {
    saved : false,
    pen_html : ``,
    pen_css :  ``,
    pen_js : ``,
    pen_title : 'untitled',
    pen_description : '',
    pen_id : null,
    pen_user_id : null,
    pen_user_name : '',
    user_photo_url : '',
    jsSettings: {
        jsCdnList: []
    },
    cssSettings: {
        cssCdnList: []
    },
    htmlSettings: {
        htmlClassTag: '',
        head: ''
    },
    loves : [],
    forks : [],
    views : 0,
    love_count : 0,
    fork_count : 0,
}

export const setPenHtml = (payload) => ({
    type: type.SET_PEN_HTML,
    payload
});

export const setPenCss = (payload) => ({
    type: type.SET_PEN_CSS,
    payload
});

export const setPenJS = (payload) => ({
    type: type.SET_PEN_JS,
    payload
});

export const setPenTitle = (payload) => ({
    type: type.SET_PEN_TITLE,
    payload
});

export const setPenDescription= (payload) => ({
    type: type.SET_PEN_DESCRIPTION,
    payload
});

export const addCssCdn = (payload) => ({
    type : type.ADD_CSS_CDN,
    payload
});

export const removeCssCdn = (payload) => ({
    type : type.REMOVE_CSS_CDN,
    payload
});

export const addJsCdn = (payload) => ({
    type : type.ADD_JS_CDN,
    payload
});
export const removeJsCdn = (payload) => ({
    type : type.REMOVE_JS_CDN,
    payload
});

export const classTagHandler = (payload) => ({
    type : type.SET_CLASS_TAG,
    payload
});

export const setHeadStuff = (payload) => ({
    type : type.SET_HEAD_STUFF,
    payload
});

export const loadPen = (payload) => ({
    type : type.LOAD_PEN,
    payload
})


export const setDefaultPen = () => ({
    type : type.SET_DEFAULT_PEN,
    payload : defaultPen
})


// WEBPACK FOOTER //
// ./src/redux/actions/penActions.js